module.exports = __webpack_public_path__ + "static/media/1018023.2666e746.jpg";